import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { FullPriceContainerBlockLarge, MicroCopy } from 'pricing-pages-ui-components/price/PriceStyledComponents';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightedFreePriceDisplay = () => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: "400",
    children: [/*#__PURE__*/_jsx(FullPriceContainerBlockLarge, {
      children: /*#__PURE__*/_jsx(PriceDisplay, {
        price: 0,
        currencyCode: currencyCode,
        dataSelenium: "free-highlighted-price-per-month",
        currencyCodeUnit: currencyCodeUnit
      })
    }), /*#__PURE__*/_jsx(MicroCopy, {
      use: "help",
      children: isSeatsRedesignUngated ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "priceDisplay.highlightedPrice.subtexts.free.current"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "priceDisplay.highlightedPrice.subtexts.free.legacy"
      })
    })]
  });
};
export default HighlightedFreePriceDisplay;